import { render, staticRenderFns } from "./Gate.vue?vue&type=template&id=2caf34cb&scoped=true"
import script from "./Gate.vue?vue&type=script&lang=js"
export * from "./Gate.vue?vue&type=script&lang=js"
import style0 from "./Gate.vue?vue&type=style&index=0&id=2caf34cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf34cb",
  null
  
)

export default component.exports